import { FlexPane } from './FlexPane';

export default FlexPane;
